/**
 * BGDesignModal
 * -------------
 * Lightweight, reusable modal for resolved design/template previews.
 * Used by Foundation-backed template collection grids and legacy-compatible
 * storefront flows that provide a normalized design object.
 *
 * Usage from Liquid-generated JS:
 *   BGDesignModal.openDesign(designObject)
 *
 * Where `designObject` is an item from the resolved template catalog payload.
 */
(function bgEnsureBusinessCardsVariantQuery() {
  try {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    var pathname = (window.location && window.location.pathname ? window.location.pathname : '').replace(/\/+$/, '');
    if (pathname !== '/products/business-cards') return;
    if ((window.location.search || '').indexOf('variant=') !== -1) return;

    var redirectFlag = '__bgBusinessCardsVariantRedirected';
    if (window.sessionStorage && window.sessionStorage.getItem(redirectFlag) === '1') return;

    var redirectToFirstVariant = function () {
      var variantField = document.querySelector('form[action="/cart/add"] input[name="id"], input[name="id"][form*="product-form"]');
      var variantId = variantField && variantField.value ? String(variantField.value).trim() : '';
      if (!variantId || !/^\d+$/.test(variantId)) return;

      if (window.sessionStorage) {
        try { window.sessionStorage.setItem(redirectFlag, '1'); } catch (_) {}
      }
      var hash = window.location.hash || '';
      window.location.replace(window.location.pathname + '?variant=' + encodeURIComponent(variantId) + hash);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', redirectToFirstVariant, { once: true });
    } else {
      redirectToFirstVariant();
    }
  } catch (_) {}
})();

(function bgRecoverBogunaLegacyTemplatePicker() {
  try {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    var host = String(window.location && window.location.host || '').toLowerCase();
    if (host.indexOf('boguna') === -1 && host.indexOf('4492ca-12') === -1) return;
    if (!/^\/products\//.test(window.location && window.location.pathname || '')) return;
    if (window.__bgLegacyTemplatePickerRecoveryStarted) return;

    function hasGuidedTemplateFlow() {
      return !!document.getElementById('bgGuidedArtworkFlow');
    }

    function hasPickerOpen() {
      return typeof window.bgTemplatePickerOpen === 'function';
    }

    function findPickerScript(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var scripts = Array.prototype.slice.call(doc.querySelectorAll('script'));
      for (var i = 0; i < scripts.length; i += 1) {
        var text = scripts[i].textContent || '';
        if (text.indexOf('BGFreeTemplateSetupPicker') !== -1 && text.indexOf('Liquid error') === -1) {
          return text;
        }
      }
      return '';
    }

    function buildFreshRenderUrl() {
      var url = new URL(window.location.href);
      url.searchParams.set('view', 'default');
      url.searchParams.set('bg-picker-recover', String(Date.now()));
      return url.toString();
    }

    function runPickerScript(scriptText) {
      if (!scriptText) return false;
      try {
        window.__BG_FREE_TEMPLATE_SETUP_PICKER__ = false;
        delete window.__BG_FREE_TEMPLATE_SETUP_PICKER__;
      } catch (_) {
        window.__BG_FREE_TEMPLATE_SETUP_PICKER__ = false;
      }
      var script = document.createElement('script');
      script.text = scriptText;
      document.body.appendChild(script);
      return true;
    }

    function recoverPicker() {
      if (hasPickerOpen()) return;
      if (!hasGuidedTemplateFlow()) return;
      window.__bgLegacyTemplatePickerRecoveryStarted = true;
      fetch(buildFreshRenderUrl(), { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          if (hasPickerOpen()) return;
          if (!runPickerScript(findPickerScript(html))) {
            window.__bgLegacyTemplatePickerRecoveryStarted = false;
            return;
          }
          setTimeout(function () {
            if (!hasPickerOpen()) window.__bgLegacyTemplatePickerRecoveryStarted = false;
          }, 2500);
        })
        .catch(function () {
          window.__bgLegacyTemplatePickerRecoveryStarted = false;
        });
    }

    function scheduleRecovery() {
      if (hasPickerOpen()) return;
      setTimeout(recoverPicker, 1200);
      setTimeout(recoverPicker, 3500);
      setTimeout(recoverPicker, 7000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleRecovery, { once: true });
    } else {
      scheduleRecovery();
    }
    window.addEventListener('load', scheduleRecovery, { once: true });
  } catch (_) {}
})();

(function () {
  if (window.BGDesignModal) return;

  const PRICING_URL = "//boguna.com/cdn/shop/t/12/assets/bg-master-pricing-data.json?v=12120919118994880201790679611";

  let masterPricing = null;
  let pricingLoaded = false;
  let pricingLoadPromise = null;
  let referencePriceGeneration = 0;

  const DISCOUNT_TAGS = [
    'discount50','discount45','discount40','discount35','discount30',
    'discount25','discount20','discount15','discount10','discount5'
  ];

  function getMemberDiscount() {
    if (window.ultimatePlan) return { bonus: 0, label: 'Ultimate Member' };
    if (window.proPlan) return { bonus: 0, label: 'Pro Member' };
    return { bonus: 0, label: '' };
  }

  let allDesigns = [];
  let designByNumber = {};
  let designSuiteIndex = {};

  const SIZE_LABEL_PRIORITY = {
    'standard': 0,
    'credit card': 1
  };

  function getDesignKey(design) {
    return String(
      design && (
        design.designnum
        || design.templateLookup
        || design.templatePublicId
        || design.publicId
        || design.id
      ) || ''
    ).trim();
  }

  function getTemplateLookupForDesign(design) {
    return String(
      design && (
        design.templateLookup
        || design.templatePublicId
        || design.publicId
        || design.__foundationNativeTemplatePublicId
      ) || ''
    ).trim();
  }

  function normalizeDesignPrintingValue(value) {
    const normalized = String(value || '')
      .toLowerCase()
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    if (/^(?:print\s+)?(?:1|one)\s+colou?r(?:\b|$)/.test(normalized)) return '1 Color';
    // Prefix matching also accepts the current concatenated legacy import tag.
    if (/^(?:print\s+)?full\s+colou?r/.test(normalized)) return 'Full Color';
    return '';
  }

  function getDesignPrintingValue(design) {
    const tags = Array.isArray(design && design.tags)
      ? design.tags
      : String(design && design.tags || '').split(',');
    for (const tag of tags) {
      const printing = normalizeDesignPrintingValue(tag);
      if (printing) return printing;
    }
    return '';
  }

  function getDesignPrintingTargetingID(design) {
    const printing = getDesignPrintingValue(design);
    if (printing === '1 Color') return 'print-1-color';
    if (printing === 'Full Color') return 'print-full-color';
    return '';
  }

  function ensurePricingLoaded(design) {
    const reader = window.BGReferencePricing;
    if (!reader) return Promise.resolve();
    return reader.load({ productHandle: reader.handle(design) }).then(function (entry) {
      return entry.status === 'legacy' ? ensureLegacyPricingLoaded() : null;
    });
  }

  function ensureLegacyPricingLoaded() {
    if (pricingLoaded) return Promise.resolve();
    if (pricingLoadPromise) return pricingLoadPromise;

    pricingLoadPromise = fetch(PRICING_URL)
      .then((r) => r.json())
      .then((data) => {
        masterPricing = data && data.pricing ? data.pricing : (data || {});
        window.MasterPricingData = data || {};
        pricingLoaded = true;
      })
      .catch((err) => {
        console.error('[BGDesignModal] Error loading pricing JSON:', err);
        pricingLoaded = true;
      });

    return pricingLoadPromise;
  }

  // SALE-DISPLAY-STRIKETHROUGH (owner, 2026-10-08): the store's tier sale, as the
  // designs collection table shows it (bg-designs-collection-core.js): Shopify's
  // floor per unit, the row crossed out and the price after it; a sale with no
  // tier behind it (a discountNN tag) keeps the sentence.
  function tierSaleLineCents(lineCents, pct, quantity) {
    var cents = Math.round(Number(lineCents));
    var rate = Math.round(Number(pct));
    var count = Math.max(1, Math.floor(Number(quantity) || 1));
    if (!Number.isSafeInteger(cents) || cents <= 0 || !(rate > 0) || rate >= 100) return cents;
    var unit = Math.floor(cents / count);
    var cut = unit * rate;
    return count * (unit - ((cut - (cut % 100)) / 100));
  }

  function readTierSalePercent(handle) {
    const value = Number(window.productTierSalePercents && window.productTierSalePercents[handle]);
    return Number.isInteger(value) && value > 0 && value < 100 ? value : 0;
  }

  // Fix round 1 (Astra P2 #6, review of #673): the badge beside the price
  // table names the percent that owns the shown price pair, the store's tier
  // sale (readTierSalePercent), never a discountNN tag, the legacy map or a
  // member bonus. Without the tier sale the rows are before discounts with the
  // sentence, so no sale badge shows; Unbeatable Price is not a discount and
  // stays (the design page's rule, getShownDiscountBadgeText).
  const UNBEATABLE_PRICE_BADGE = 'Unbeatable Price';

  function buildShownSaleBadgeText(handle) {
    const tierPct = readTierSalePercent(handle);
    if (tierPct > 0) return tierPct + '% Off Sale';
    return hasUnbeatablePriceTag(handle) ? UNBEATABLE_PRICE_BADGE : '';
  }

  function buildLivePriceTable(design, discountPct) {
    const tierPct = readTierSalePercent(design && design.handle ? String(design.handle) : '');
    const container = document.getElementById('bg-design-modal-price-table');
    if (!container) return;

    const reader = window.BGReferencePricing;
    const entry = reader && !reader.linksElsewhere(design) ? reader.peek({ productHandle: reader.handle(design) }) : null;
    if (!entry || entry.status !== 'legacy') {
      container.innerHTML = reader && entry && entry.status === 'admin' ? reader.tableHtml(entry, Object.assign({}, design, { Printing_targetingID: getDesignPrintingTargetingID(design) || design.Printing_targetingID }), discountPct) : '<p class="no-pricing">Pricing will be confirmed on the product page.</p>';
      const disclaimer = String(design.pricing_disclaimer || '').trim();
      if (disclaimer) {
        const node = document.createElement('p');
        node.className = 'pricing-disclaimer';
        node.textContent = disclaimer;
        node.style.marginBottom = '10px';
        container.insertAdjacentElement('afterbegin', node);
      }
      return;
    }

    if (!design.base_partial_sku) {
      container.innerHTML = '<p class="no-pricing">No pricing data available.</p>';
      return;
    }

    const partialSku = (design.base_partial_sku || '').trim();
    if (!partialSku) {
      container.innerHTML = '<p class="no-pricing">Pricing will be confirmed on the product page.</p>';
      return;
    }

    if (!masterPricing) {
      container.innerHTML = '<p class="no-pricing">Pricing data not loaded.</p>';
      return;
    }

    const matched = [];
    for (const sku in masterPricing) {
      if (Object.prototype.hasOwnProperty.call(masterPricing, sku) && sku.startsWith(partialSku + '-q')) {
        matched.push(sku);
      }
    }

    matched.sort((a, b) => extractQty(a) - extractQty(b));

    if (!matched.length) {
      container.innerHTML = '<p class="no-pricing">Pricing will be confirmed on the product page.</p>';
      return;
    }

    let html = `
      <table class="price-table">
        <thead>
          <tr>
            <th>Quantity</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody>
    `;

    // OD-122 (SALE-DISPLAY-OTHER-SURFACES, 2026-10-06; as the designs collection table):
    // a sale percent is not what checkout charges (Shopify takes the sale off itself and
    // rounds it, and a credit or a code can replace it), so every row shows its price
    // before discounts and a sale adds the sentence under the table.
    matched.forEach((sku) => {
      const priceObj = masterPricing[sku] || {};
      const total = exactRowAmount(parseFloat(priceObj.price || 0));
      const qty = extractQty(sku);
      const each = qty > 0 ? total / qty : 0;

      const totalCents = Math.round(total * 100);
      const saleCents = tierPct > 0 ? tierSaleLineCents(totalCents, tierPct, 1) : totalCents;
      html += '<tr><td>' + qty + '</td><td>';
      if (saleCents < totalCents) {
        const saleEach = qty > 0 ? Math.ceil(saleCents / qty - 1e-7) / 100 : saleCents / 100;
        html +=
          '<s>$' + total.toFixed(2) + '</s> ' +
          '<span class="bg-dc-sale-price">$' + (saleCents / 100).toFixed(2) + '</span>' +
          '&nbsp;<em>($' + saleEach.toFixed(2) + '/ea)</em>';
      } else {
        html +=
          '$' + total.toFixed(2) +
          '&nbsp;<em>($' + each.toFixed(2) + '/ea)</em>';
      }
      html += '</td></tr>';
    });

    html += '</tbody></table>';
    if (discountPct > 0 && !(tierPct > 0)) {
      html += '<p class="bg-dc-sale-pending-note" role="status" style="margin:8px 0 0;font-size:12px;line-height:1.5;opacity:.8;">Price before discounts. Final discounts are calculated at checkout.</p>';
    }
    container.innerHTML = html;

    const disclaimer = (design.pricing_disclaimer || '').trim();
    if (disclaimer) {
      const p = document.createElement('p');
      p.className = 'pricing-disclaimer';
      p.textContent = disclaimer;
      p.style.marginBottom = '10px';
      container.insertAdjacentElement('afterbegin', p);
    }
  }

  // EXACT-CENTS-CATALOG (2026-10-03): a price row as authored, shown in the cents the
  // product page and the cart charge (the quote engine's half-up cent: toFixed showed a
  // 135.795 row as 135.79). A positive price row only.
  function exactRowAmount(value) {
    var micros = Math.round(Number(value) * 1000000);
    return Number.isFinite(micros) ? Math.round(micros / 10000) / 100 : value;
  }

  function extractQty(skuStr) {
    const parts = String(skuStr || '').split('-q');
    if (parts.length < 2) return 0;
    const num = parseInt(parts[1], 10);
    return Number.isNaN(num) ? 0 : num;
  }

  function extractBaseDiscountFromTags(handle) {
    if (!handle) return 0;

    const mapDiscount = window.productDiscounts && window.productDiscounts[handle];
    const parsedMapDiscount = parseInt(mapDiscount, 10);
    if (!Number.isNaN(parsedMapDiscount) && parsedMapDiscount > 0) {
      return Math.min(100, parsedMapDiscount);
    }

    const tagsString = (window.productTags && window.productTags[handle]) || '';
    if (!tagsString) return 0;
    const tagArray = tagsString.split(',').map((t) => t.trim().toLowerCase());
    for (let i = 0; i < DISCOUNT_TAGS.length; i++) {
      const tag = DISCOUNT_TAGS[i];
      if (tagArray.includes(tag)) {
        const num = parseInt(tag.replace('discount', ''), 10);
        return Number.isNaN(num) ? 0 : num;
      }
    }
    return 0;
  }

  function hasUnbeatablePriceTag(handle) {
    if (!handle) return false;
    const tagsString = (window.productTags && window.productTags[handle]) || '';
    if (!tagsString) return false;
    return tagsString.split(',').some((tag) => tag.trim().toLowerCase() === 'unbeatable-price');
  }

  function applyMembershipDiscount(basePercent) {
    if (!basePercent || basePercent <= 0) {
      return { percent: basePercent || 0, label: '', hasBonus: false };
    }
    const member = getMemberDiscount();
    const bonus = member.bonus;
    if (bonus > 0) {
      const adjusted = Math.min(100, basePercent + bonus);
      return { percent: adjusted, label: member.label, hasBonus: true };
    }
    return { percent: basePercent, label: '', hasBonus: false };
  }

  function computeDiscountPercent(design) {
    const handle = design && design.handle ? String(design.handle) : '';
    const base = extractBaseDiscountFromTags(handle);
    const result = applyMembershipDiscount(base);
    return result.percent || 0;
  }

  // Flat preview with a real back side: image on top, Front/Back buttons under
  // it. Ported from bg-designs-collection-core.js so the shared product-page
  // modal keeps the same affordance the collection modal repaired on
  // 2026-07-24; single-image (or identical-back) designs degrade to the plain
  // flat preview.
  function renderFlatPreview(mount, imgs, opt, altText) {
    if (!mount) return;

    const list  = Array.isArray(imgs) ? imgs.filter(Boolean) : [];
    const front = list[0] || '';
    const back  = list[1] || '';
    const alt   = (altText || '').toString().replace(/"/g, '&quot;');

    if (!back || back === front) {
      mount.innerHTML = `<div class="bg-flat-preview"><img src="${front}" alt="${alt}" loading="lazy"></div>`;
      return;
    }

    // A caller that asked to open on the back (e.g. a chosen backer) passes
    // initialAngle 180; honour that here the same way the cube does.
    const angle = Number(opt && opt.initialAngle);
    const norm  = isFinite(angle) ? (((angle % 360) + 360) % 360) : 0;
    const startOnBack = norm > 90 && norm < 270;

    mount.innerHTML = `
      <div class="bg-flat-preview bg-flat-preview--faces">
        <div class="bg-flat-preview__stage">
          <img src="${startOnBack ? back : front}" alt="${alt}" loading="lazy">
        </div>
        <div class="bg-flat-preview__controls" role="group" aria-label="Preview side">
          <button type="button" class="bg-3d-preview__fb${startOnBack ? '' : ' is-active'}"
                  data-face="front" aria-pressed="${startOnBack ? 'false' : 'true'}">Front</button>
          <button type="button" class="bg-3d-preview__fb${startOnBack ? ' is-active' : ''}"
                  data-face="back" aria-pressed="${startOnBack ? 'true' : 'false'}">Back</button>
        </div>
      </div>`;

    // Warm the off-screen side so the first toggle does not flash.
    const warm = new Image();
    warm.src = startOnBack ? front : back;

    const img  = mount.querySelector('.bg-flat-preview__stage img');
    const btns = [...mount.querySelectorAll('.bg-flat-preview__controls .bg-3d-preview__fb')];
    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        img.src = btn.dataset.face === 'back' ? back : front;
        btns.forEach(b => {
          const active = (b === btn);
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });
  }

  function openModal() {
    const modal = document.getElementById('bg-design-modal');
    if (!modal) return;
    modal.style.display = 'flex';
    document.body.classList.add('modal-open');
  }

  function closeModal() {
    const modal = document.getElementById('bg-design-modal');
    if (!modal) return;
    modal.style.display = 'none';
    document.body.classList.remove('modal-open');
    modal.dispatchEvent(new CustomEvent('modal:close'));
  }

  function wireModalCloseOnce() {
    const modal = document.getElementById('bg-design-modal');
    if (!modal || modal.__bgModalWired) return;
    modal.__bgModalWired = true;

    const closeBtn = document.querySelector('#bg-design-modal .bg-design-modal__close');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        closeModal();
      }
    });
  }

  function fillContent(design) {
    const titleEl = document.getElementById('bg-design-modal-title');
    const metaEl = document.getElementById('bg-design-modal-meta');
    const badgesEl = document.getElementById('bg-design-modal-badges');
    const customizeEl = document.getElementById('bg-design-modal-customize');
    const editServiceEl = document.getElementById('bg-design-modal-edit-service');
    const ctaRowEl = document.querySelector('.bg-design-modal__cta-row');
    const imagesContainer = document.querySelector('.bg-design-modal__images');

    // The preview replaces its image on the first open. Subsequent product
    // and size switches depend on the stable container, not the old image.
    if (!titleEl || !metaEl || !badgesEl || !customizeEl || !editServiceEl || !ctaRowEl || !imagesContainer) return;

    const previews = Array.isArray(design.previews) ? design.previews : [];

    titleEl.textContent = design.template_name || '';

    const product = design.product || '';
    const size = design.size || '';
    const pieces = [];
    if (product) pieces.push(product);
    if (size) pieces.push(size);
    metaEl.textContent = pieces.join(' • ');

    badgesEl.innerHTML = '';

    const handle = design && design.handle ? String(design.handle) : '';
    // The configured percent (a tag, the legacy map, a member bonus) still
    // decides the table's sentence (buildLivePriceTable).
    const discountPct = computeDiscountPercent(design);
    const badgeText = buildShownSaleBadgeText(handle);
    const isUnbeatableBadge = badgeText === UNBEATABLE_PRICE_BADGE;

    if (badgeText) {
      const span = document.createElement('span');
      span.className = `bg-design-modal__badge${isUnbeatableBadge ? ' bg-design-modal__badge--unbeatable' : ''}`;
      span.innerHTML = badgeText;
      badgesEl.appendChild(span);
    }

    const ps = design.preview_settings || {};
    const targetAR = getDesignAspectRatio(design);
    const nameLower = (design.template_name || '').toString().toLowerCase().trim();
    const isPlaceholder =
      nameLower === 'upload completed design' ||
      nameLower === 'start from scratch';

    const fallbackImg = previews[0] || '//boguna.com/cdn/shop/t/12/assets/logo-placeholder.jpg?v=1436316463287943271761500260';

    function initPreview(previewsArr, wantBack) {
      const arr = Array.isArray(previewsArr) ? previewsArr : [];
      const context = typeof window.BGDesignModalContext === 'string'
        ? window.BGDesignModalContext
        : '';
      const allow3D = context !== 'featured-design-carousel';

      if (!arr.length || !window.BG3DPreview || isPlaceholder || !allow3D) {
        renderFlatPreview(
          imagesContainer,
          arr.length ? arr : [fallbackImg],
          { initialAngle: wantBack ? 180 : 0 },
          design.template_name || 'Design preview'
        );
        return;
      }

      window.BG3DPreview.init(imagesContainer, arr, {
        enable      : ps.enable_3d === true,
        autoRotate  : ps.auto_rotate === true,
        wobble      : wantBack ? false : (ps.wobble === true),
        rotateSpeed : ps.rotate_speed || 18,
        finish      : ps.surface_finish || 'matte',
        depth       : ps.depth_px ?? 2,
        edgeColor   : ps.edge_color || '#fafafa',
        initialAngle: wantBack ? 180 : (ps.initial_angle || 0),
        targetAR    : targetAR
      });
    }

    const backers = Array.isArray(design.backers) ? design.backers : [];
    if (backers.length) {
      renderBackersUIShared(design, imagesContainer, initPreview);
    } else {
      initPreview(previews, false);
      const backerSection = document.getElementById('bg-design-modal-backers');
      if (backerSection) {
        backerSection.style.display = 'none';
      }
    }

    function getDesignModalProductUrl(inputDesign) {
      try {
        if (typeof window.BGTemplatePageProductUrlResolver === 'function') {
          const resolvedUrl = window.BGTemplatePageProductUrlResolver(inputDesign);
          if (resolvedUrl) return resolvedUrl;
        }
      } catch (_) {}
      const foundationProductUrl = String(inputDesign && inputDesign.__foundationProductUrl || '').trim();
      if (foundationProductUrl) return foundationProductUrl;
      const foundationHandle = String(inputDesign && (
        inputDesign.__foundationReturnProductHandle
        || inputDesign.__foundationTargetProductHandle
        || inputDesign.__foundationTargetTemplateSourceHandle
      ) || '').trim();
      if (foundationHandle) return '/products/' + encodeURIComponent(foundationHandle);
      return '';
    }

    const productUrl = getDesignModalProductUrl(design);

    const fromParam = typeof window.BGDesignModalContext === 'string'
      ? window.BGDesignModalContext
      : 'featured';

    const designHandoffId = (function getDesignHandoffId() {
      const explicitId = String(design && design.id || '').trim();
      if (explicitId) return explicitId;
      const designNum = String(design && design.designnum || '').trim();
      if (designNum) return 'designnum:' + designNum;
      return getTemplateLookupForDesign(design);
    })();

    function buildDesignModalUrl(baseUrl, params) {
      try {
        const url = new URL(baseUrl, window.location.origin);
        Object.keys(params || {}).forEach(key => {
          const value = params[key];
          if (value === undefined || value === null || value === '') return;
          url.searchParams.set(key, value);
        });
        const rawBase = String(baseUrl || '');
        if (/^https?:\/\//i.test(rawBase)) return url.toString();
        if (rawBase.indexOf('//') === 0) return url.toString().replace(/^https?:/, '');
        return url.pathname + url.search + url.hash;
      } catch (error) {
        const query = Object.keys(params || {})
          .filter(key => params[key] !== undefined && params[key] !== null && params[key] !== '')
          .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
          .join('&');
        if (!query) return baseUrl;
        return baseUrl + (String(baseUrl || '').includes('?') ? '&' : '?') + query;
      }
    }

    const customizeParams = {
      id: design.id || '',
      designnum: design.designnum || '',
      templateLookup: getTemplateLookupForDesign(design),
      Printing: getDesignPrintingTargetingID(design),
      from: fromParam
    };
    if (!isPlaceholder) {
      customizeParams.artwork = 'designonline';
      customizeParams.designonline = 'true';
      customizeParams.bg_template_action = 'customize_online';
    }
    let customizeHref = productUrl ? buildDesignModalUrl(productUrl, customizeParams) : '#';
    customizeHref = productUrl ? appendTargetingIDs(customizeHref, design) : customizeHref;
    customizeEl.href = customizeHref;

    // Edit service label and href (membership-aware)
    const baseCost  = parseFloat(design.edit_service_cost ?? '0') || 0;
    const saleField = design.edit_service_sale;
    const saleCost  = (saleField !== '' && saleField !== null && !isNaN(+saleField))
      ? parseFloat(saleField)
      : NaN;
    const startingPrice = !Number.isNaN(saleCost) && saleCost >= 0 ? saleCost : baseCost;

    let effectiveCost = startingPrice;
    if (window.ultimatePlan) {
      effectiveCost = 0;
    } else if (window.proPlan) {
      effectiveCost = startingPrice * 0.5;
    }

    const currency = (value) => '$' + value.toFixed(2);
    const isZero = (value) => Math.abs(value) < 0.0001;
    const hasSale = !Number.isNaN(saleCost) && saleCost >= 0 && saleCost < baseCost;

    let label;
    if (window.ultimatePlan) {
      label = 'Edit this for me (FREE with Ultimate)';
    } else if (window.proPlan) {
      label = isZero(effectiveCost)
        ? 'Edit this for me (FREE with Pro)'
        : 'Edit this for me (' + currency(effectiveCost) + ' with Pro)';
    } else if (hasSale) {
      label = isZero(saleCost)
        ? 'Edit this for me (<s>' + currency(baseCost) + '</s> <b>FREE</b>)'
        : 'Edit this for me (<s>' + currency(baseCost) + '</s> <b>' + currency(saleCost) + '</b>)';
    } else if (isZero(baseCost)) {
      label = 'Edit this for me (FREE)';
    } else {
      label = 'Edit this for me (' + currency(baseCost) + ')';
    }

    let esHref = productUrl ? buildDesignModalUrl(productUrl, {
      from: fromParam,
      id: designHandoffId,
      designnum: design.designnum || '',
      templateLookup: getTemplateLookupForDesign(design),
      Printing: getDesignPrintingTargetingID(design),
      artwork: 'editservice',
      editservice: 'true',
      bg_template_action: 'edit_service'
    }) : '#';
    esHref = productUrl ? appendTargetingIDs(esHref, design) : esHref;
    if (productUrl && window.ultimatePlan) {
      esHref = buildDesignModalUrl(esHref, { member: 'ultimate' });
    } else if (productUrl && window.proPlan) {
      esHref = buildDesignModalUrl(esHref, { member: 'pro' });
    }

    editServiceEl.href = esHref;
    editServiceEl.innerHTML = label;

    // Membership CTA (only for non-members)
    const existingMembership = ctaRowEl.parentElement.querySelector('.membership-cta');
    if (existingMembership) existingMembership.remove();
    if (window.__siteCfg?.memberships?.enabled !== false && !window.proPlan && !window.ultimatePlan) {
      const cta = document.createElement('div');
      cta.className = 'membership-cta';
      cta.innerHTML = (
        '<p style="margin:8px 0 4px;font-size:14px;">' +
          'Want <strong>FREE</strong> edit services?' +
        '</p>' +
        '<button class="bg-membership-cta-button">' +
          'Save with a Membership →' +
        '</button>'
      );
      ctaRowEl.parentElement.appendChild(cta);
      const btn = cta.querySelector('.bg-membership-cta-button');
      if (btn) {
        btn.addEventListener('click', function () {
          openMembershipModalShared();
        });
      }
    }

    buildPillsUI(design);

    // Clear the previous design's amount before either network read. A late
    // response must not replace the table after a product/size switch.
    const priceGeneration = ++referencePriceGeneration;
    const priceTable = document.getElementById('bg-design-modal-price-table');
    if (priceTable) priceTable.innerHTML = '<p class="no-pricing">Pricing will be confirmed on the product page.</p>';
    ensurePricingLoaded(design).then(function () {
      if (priceGeneration !== referencePriceGeneration) return;
      buildLivePriceTable(design, discountPct);
    });
  }

  function appendTargetingIDs(url, d) {
    ['size','shape','orientation','corners','perforation','fold','fit','equipment']
      .forEach(function (attr) {
        const id = d && d[attr + '_targetingID'];
        if (id) {
          url += '&' + encodeURIComponent(attr + '_targetingID') + '=' + encodeURIComponent(id);
        }
      });
    return url;
  }

  function getDesignAspectRatio(d) {
    if (!d) return null;
    const raw = (d.size || '').toString().trim().toLowerCase().replace(/\s+/g, '');

    let m = raw.match(/^([\d.]+)(?:in|")?x([\d.]+)(?:in|")?$/i);
    if (!m) {
      m = raw.match(/^([\d.]+)'x([\d.]+)'$/i);
      if (m) {
        const w = parseFloat(m[1]) * 12;
        const h = parseFloat(m[2]) * 12;
        if (w > 0 && h > 0) return w / h;
      }
    } else {
      const w = parseFloat(m[1]);
      const h = parseFloat(m[2]);
      if (w > 0 && h > 0) return w / h;
    }

    if (typeof d.preview_ar === 'number' && isFinite(d.preview_ar) && d.preview_ar > 0) {
      return d.preview_ar;
    }

    if (typeof d.orientation === 'string') {
      const o = d.orientation.toLowerCase();
      if (o.includes('landscape')) return 4 / 3;
      if (o.includes('portrait')) return 3 / 4;
    }

    return null;
  }

  function initFromAllTemplates(data) {
    if (!Array.isArray(data)) return;
    allDesigns = data;
    designByNumber = {};
    designSuiteIndex = {};

    allDesigns.forEach(function (d) {
      const designKey = getDesignKey(d);
      if (designKey) {
        designByNumber[designKey] = d;
      }
    });

    allDesigns.forEach(function (d) {
      const suite = (d && d.design_suite != null ? String(d.design_suite) : '').trim();
      if (!suite) return;
      if (!designSuiteIndex[suite]) designSuiteIndex[suite] = [];
      const designKey = getDesignKey(d);
      if (designKey) designSuiteIndex[suite].push(designKey);
    });

    Object.keys(designSuiteIndex).forEach(function (key) {
      const arr = designSuiteIndex[key] || [];
      designSuiteIndex[key] = Array.from(new Set(arr));
    });
  }

  function getGroupNumsForDesign(design) {
    if (!design) return [];
    const num = getDesignKey(design);
    if (!num) return [];

    const suiteKey = (design.design_suite != null ? String(design.design_suite) : '').trim();
    let groupNums;

    if (suiteKey && designSuiteIndex[suiteKey] && designSuiteIndex[suiteKey].length) {
      groupNums = Array.from(
        new Set(designSuiteIndex[suiteKey].concat([num]))
      ).filter(function (n) { return !!designByNumber[n]; });
    } else {
      const linkedStr = (design['linked designs string'] || '').trim();
      if (linkedStr) {
        const linkedNums = linkedStr
          .split(',')
          .map(function (x) { return parseInt(x.trim(), 10); })
          .filter(function (x) { return !!designByNumber[x]; });
        groupNums = Array.from(new Set([num].concat(linkedNums))).filter(function (x) { return !!designByNumber[x]; });
      } else {
        groupNums = [num];
      }
    }

    if (!groupNums.length) groupNums = [num];
    return groupNums;
  }

  function parsePhysicalDimension(str) {
    if (!str) return null;
    const s = String(str);
    const matchInches = s.match(/^(\d*\.?\d+)"?\s*x\s*(\d*\.?\d+)"?/i);
    if (matchInches) {
      const w = parseFloat(matchInches[1]);
      const h = parseFloat(matchInches[2]);
      return [w, h];
    }
    const matchFeet = s.match(/^(\d*\.?\d+)'?\s*x\s*(\d*\.?\d+)'?/i);
    if (matchFeet) {
      const w = parseFloat(matchFeet[1]) * 12;
      const h = parseFloat(matchFeet[2]) * 12;
      return [w, h];
    }
    return null;
  }

  function customSizeShapeSort(a, b) {
    const pA = parsePhysicalDimension(a);
    const pB = parsePhysicalDimension(b);
    if (pA && pB) {
      if (pA[0] !== pB[0]) return pA[0] - pB[0];
      return pA[1] - pB[1];
    } else if (pA && !pB) return -1;
    else if (!pA && pB) return 1;
    return String(a || '').localeCompare(String(b || ''));
  }

  function buildPillsUI(design) {
    const productPillsEl = document.getElementById('bg-design-modal-product-pills');
    const attributesEl = document.getElementById('bg-design-modal-attributes');
    if (!productPillsEl || !attributesEl) return;

    productPillsEl.innerHTML = '';
    attributesEl.innerHTML = '';

    const groupNums = getGroupNumsForDesign(design);
    if (!groupNums.length) return;

    const productMap = {};
    groupNums.forEach(function (n) {
      const d = designByNumber[n];
      if (!d) return;
      const p = (d.product || 'Unknown Product').trim();
      if (!productMap[p]) productMap[p] = [];
      productMap[p].push(n);
    });

    Object.keys(productMap).forEach(function (prod) {
      productMap[prod].sort(function (a, b) {
        const A = designByNumber[a];
        const B = designByNumber[b];
        return customSizeShapeSort(A && A.size || '', B && B.size || '');
      });
    });

    const currentProduct = (design.product || 'Unknown Product').trim();
    const context = typeof window.BGDesignModalContext === 'string'
      ? window.BGDesignModalContext
      : '';
    const interactivePills = context !== 'featured-design-carousel';

    Object.keys(productMap).forEach(function (prod) {
      const pill = document.createElement('div');
      pill.className = 'product-pill';
      pill.textContent = prod;
      if (prod === currentProduct) pill.classList.add('active');

      if (interactivePills) {
        pill.addEventListener('click', function () {
          const firstNum = productMap[prod][0];
          const next = designByNumber[firstNum];
          if (next) {
            fillContent(next);
          }
        });
      }

      productPillsEl.appendChild(pill);
    });

    const subset = productMap[currentProduct] || [];
    buildPrintingPills(subset, design, attributesEl, interactivePills);
    const currentPrinting = getDesignPrintingValue(design);
    const sizeSubset = currentPrinting
      ? subset.filter(function (num) {
        return getDesignPrintingValue(designByNumber[num]) === currentPrinting;
      })
      : subset;
    buildSizePills(sizeSubset, design, attributesEl, interactivePills);
  }

  function buildPrintingPills(subsetNums, currentDesign, containerEl, interactive) {
    if (!subsetNums.length) return;

    const printingValues = Array.from(new Set(subsetNums.map(function (num) {
      return getDesignPrintingValue(designByNumber[num]);
    }).filter(Boolean)));
    if (!printingValues.length) return;

    const header = document.createElement('h4');
    header.className = 'pills-header';
    header.textContent = 'Printing';
    containerEl.appendChild(header);

    const row = document.createElement('div');
    row.className = 'printing-pills-container pills-container';
    containerEl.appendChild(row);

    const currentPrinting = getDesignPrintingValue(currentDesign);
    const currentSize = String(currentDesign && currentDesign.size || '').trim();
    printingValues.sort(function (left, right) {
      return left === '1 Color' ? -1 : (right === '1 Color' ? 1 : left.localeCompare(right));
    }).forEach(function (printing) {
      const pill = document.createElement('div');
      pill.className = 'printing-pill pill';
      pill.textContent = printing;
      pill.dataset.value = printing;
      if (printing === currentPrinting) pill.classList.add('active');

      if (interactive) {
        pill.addEventListener('click', function () {
          let chosenDesign = null;
          for (let i = 0; i < subsetNums.length; i++) {
            const candidate = designByNumber[subsetNums[i]];
            if (getDesignPrintingValue(candidate) !== printing) continue;
            if (currentSize && String(candidate && candidate.size || '').trim() === currentSize) {
              chosenDesign = candidate;
              break;
            }
            if (!chosenDesign) chosenDesign = candidate;
          }
          if (chosenDesign) fillContent(chosenDesign);
        });
      }

      row.appendChild(pill);
    });
  }

  function buildSizePills(subsetNums, currentDesign, containerEl, interactive) {
    if (!subsetNums.length) return;

    const valuesSet = new Set();
    const sizeDisplayMap = new Map();

    subsetNums.forEach(function (num) {
      const dObj = designByNumber[num];
      if (!dObj || !dObj.size) return;
      const raw = String(dObj.size).trim();
      if (!raw) return;
      const sda = (dObj.size_display_as || '').toString().trim();
      const display = sda || raw;
      if (!sizeDisplayMap.has(raw)) sizeDisplayMap.set(raw, display);
      valuesSet.add(raw);
    });

    if (!valuesSet.size) return;

    const header = document.createElement('h4');
    header.className = 'pills-header';
    header.textContent = 'Size';
    containerEl.appendChild(header);

    const row = document.createElement('div');
    row.className = 'size-pills-container pills-container';
    containerEl.appendChild(row);

    const sortedVals = Array.from(valuesSet).sort(function (a, b) {
      const dispA = sizeDisplayMap.get(a) || a;
      const dispB = sizeDisplayMap.get(b) || b;

      const baseA = (dispA.split('(')[0] || dispA).trim().toLowerCase();
      const baseB = (dispB.split('(')[0] || dispB).trim().toLowerCase();

      const rankA = Object.prototype.hasOwnProperty.call(SIZE_LABEL_PRIORITY, baseA)
        ? SIZE_LABEL_PRIORITY[baseA]
        : Number.POSITIVE_INFINITY;
      const rankB = Object.prototype.hasOwnProperty.call(SIZE_LABEL_PRIORITY, baseB)
        ? SIZE_LABEL_PRIORITY[baseB]
        : Number.POSITIVE_INFINITY;

      if (rankA !== rankB) return rankA - rankB;
      return customSizeShapeSort(a, b);
    });

    const currentSize = (currentDesign.size || '').trim();

    sortedVals.forEach(function (rawSize) {
      const pill = document.createElement('div');
      pill.className = 'size-pill pill';
      pill.textContent = sizeDisplayMap.get(rawSize) || rawSize;
      pill.dataset.value = rawSize;
      if (rawSize === currentSize) pill.classList.add('active');

      if (interactive) {
        pill.addEventListener('click', function () {
          const chosen = (pill.dataset.value || '').trim();
          let chosenDesign = null;
          for (let i = 0; i < subsetNums.length; i++) {
            const dObj = designByNumber[subsetNums[i]];
            if (dObj && String(dObj.size || '').trim() === chosen) {
              chosenDesign = dObj;
              break;
            }
          }
          if (chosenDesign) {
            fillContent(chosenDesign);
          }
        });
      }

      row.appendChild(pill);
    });
  }

  window.BGDesignModal = {
    /**
     * Open modal for a given resolved design object.
     */
    openDesign: function (design) {
      if (!design) {
        console.warn('[BGDesignModal] openDesign called without design');
        return;
      }
      wireModalCloseOnce();
      fillContent(design);
      openModal();
    },

    initFromAllTemplates: function (data) {
      initFromAllTemplates(data);
    }
  };

  if (Array.isArray(window.BGDesignModalBootstrapData)) {
    initFromAllTemplates(window.BGDesignModalBootstrapData);
  }

  function openMembershipModalShared() {
    if (typeof window.openMembershipModal === 'function') {
      window.openMembershipModal();
      return;
    }
    const modal = document.getElementById('bg-membership-modal');
    if (!modal) return;
    modal.style.display = 'flex';
    document.body.classList.add('modal-open');
    const closeBtn = modal.querySelector('.membership-close');
    const outsideClick = function (e) {
      if (e.target === modal) close();
    };
    function close() {
      modal.style.display = 'none';
      document.body.classList.remove('modal-open');
      window.removeEventListener('click', outsideClick);
    }
    if (closeBtn) closeBtn.onclick = close;
    window.addEventListener('click', outsideClick);
  }

  function renderBackersUIShared(designObj, imagesContainer, initPreviewFn) {
    const backers = Array.isArray(designObj.backers) ? designObj.backers : [];
    const section = document.getElementById('bg-design-modal-backers');
    if (!section) return;
    const pillsEl = section.querySelector('.backer-pills');
    const thumbsEl = section.querySelector('.backer-thumbs');

    if (!backers.length) {
      section.style.display = 'none';
      if (pillsEl) pillsEl.innerHTML = '';
      if (thumbsEl) thumbsEl.innerHTML = '';
      return;
    }

    section.style.display = 'block';
    if (pillsEl) pillsEl.innerHTML = '';
    if (thumbsEl) thumbsEl.innerHTML = '';

    const urlBacker = new URL(location.href).searchParams.get('backer');
    const defaultId = (designObj.default_backer_id || '').toString();
    let currentId = urlBacker && backers.some(function (b) {
      return (b.id || '').toLowerCase() === urlBacker.toLowerCase();
    })
      ? urlBacker
      : (defaultId || backers[0].id);

    backers.forEach(function (b) {
      if (!pillsEl) return;
      const pill = document.createElement('div');
      pill.className = 'backer-pill';
      pill.textContent = b.label || b.id;
      if ((b.id || '').toLowerCase() === currentId.toLowerCase()) pill.classList.add('active');
      pill.addEventListener('click', function () { selectBacker(b.id); });
      pillsEl.appendChild(pill);
    });

    backers.forEach(function (b) {
      if (!thumbsEl) return;
      const box = document.createElement('div');
      box.className = 'backer-thumb';
      box.dataset.backerId = b.id;
      box.setAttribute('role', 'button');
      box.setAttribute('tabindex', '0');
      box.setAttribute('aria-pressed', 'false');
      if ((b.id || '').toLowerCase() === currentId.toLowerCase()) {
        box.classList.add('selected');
        box.setAttribute('aria-pressed', 'true');
      }

      const imgWrap = document.createElement('div');
      imgWrap.className = 'backer-thumb-img';

      const img = document.createElement('img');
      img.loading = 'lazy';
      img.alt = (b.label || b.id) + ' backer';
      img.src = b.thumb || (Array.isArray(b.previews) ? (b.previews[1] || b.previews[0] || '') : '');
      imgWrap.appendChild(img);

      const label = document.createElement('div');
      label.className = 'backer-thumb-label';
      label.textContent = b.label || b.id;

      box.appendChild(imgWrap);
      box.appendChild(label);

      const activate = function () { selectBacker(b.id); };
      box.addEventListener('click', activate);
      box.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activate();
        }
      });

      thumbsEl.appendChild(box);
    });

    const initial = backers.find(function (x) {
      return (x.id || '').toLowerCase() === currentId.toLowerCase();
    });
    if (initial && Array.isArray(initial.previews) && initial.previews.length) {
      initPreviewFn(initial.previews, true);
      updateBackerParamOnCTAsShared(currentId);
    }

    function selectBacker(id) {
      currentId = id;

      if (pillsEl) {
        pillsEl.querySelectorAll('.backer-pill').forEach(function (el) {
          el.classList.remove('active');
        });
      }

      if (thumbsEl) {
        thumbsEl.querySelectorAll('.backer-thumb').forEach(function (el) {
          const isMe = (el.dataset.backerId || '').toLowerCase() === id.toLowerCase();
          el.classList.toggle('selected', isMe);
          el.setAttribute('aria-pressed', String(isMe));
        });
      }

      const obj = backers.find(function (b) {
        return (b.id || '').toLowerCase() === id.toLowerCase();
      });
      const previewsArr = Array.isArray(obj && obj.previews) && obj.previews.length ? obj.previews : (designObj.previews || []);
      initPreviewFn(previewsArr, true);

      updateBackerParamOnCTAsShared(id);
    }
  }

  function updateBackerParamOnCTAsShared(backerId) {
    if (!backerId) return;
    const upgrade = function (href) {
      try {
        const u = new URL(href, location.origin);
        u.searchParams.set('backer', backerId);
        return u.toString();
      } catch (e) {
        return href + (href.includes('?') ? '&' : '?') + 'backer=' + encodeURIComponent(backerId);
      }
    };

    ['bg-design-modal-customize', 'bg-design-modal-edit-service'].forEach(function (id) {
      const a = document.getElementById(id);
      if (a && a.href) {
        a.href = upgrade(a.href);
      }
    });
  }

  (function () {
    function arrowSVG(mirror) {
      const path = '<path d="M4 0l6 6-6 6"/>';
      return '<svg aria-hidden="true" focusable="false" viewBox="0 0 12 12" style="' +
        (mirror ? 'transform:scaleX(-1);' : '') +
        '">' + path + '</svg>';
    }

    window.BG3DPreview = {
      init(mount, imgs, opt) {
        opt = Object.assign({
          enable       : false,
          autoRotate   : false,
          wobble       : false,
          rotateSpeed  : 18,
          depth        : 2,
          edgeColor    : '#fafafa',
          finish       : 'glossy',
          initialAngle : 0,
          targetAR     : null
        }, opt || {});

        if (!mount || !imgs || !imgs.length || !opt.enable) {
          if (mount) renderFlatPreview(mount, imgs, opt);
          return;
        }

        const metadataAR = (typeof opt.targetAR === 'number' && isFinite(opt.targetAR) && opt.targetAR > 0)
          ? opt.targetAR
          : null;

        const fallbackBoxAR = () => {
          const r = mount.getBoundingClientRect();
          return Math.max(0.1, (r.width || 1) / (r.height || 1));
        };

        const resolveAR = function (imgAR) {
          if (typeof imgAR === 'number' && isFinite(imgAR) && imgAR > 0) return imgAR;
          if (metadataAR) return metadataAR;
          return fallbackBoxAR();
        };

        const probe = new Image();
        probe.onload = function () {
          const imgAR = (probe.naturalWidth && probe.naturalHeight)
            ? (probe.naturalWidth / probe.naturalHeight)
            : null;
          buildCube(resolveAR(imgAR));
        };
        probe.onerror = function () {
          console.warn('[3D] probe failed; using mount box AR as fallback');
          buildCube(resolveAR(null));
        };
        probe.src = imgs[0];

        function buildCube(ar) {
          mount.innerHTML = '';

          const wrap = document.createElement('div');
          wrap.className = 'bg-3d-preview';
          wrap.style.setProperty('--cube-ar', ar.toFixed(6));
          wrap.style.setProperty('--cube-depth', opt.depth + 'px');
          wrap.style.setProperty('--cube-edge', opt.edgeColor);
          mount.appendChild(wrap);

          wrap.innerHTML =
            '<div class="bg-3d-preview__scene ' + opt.finish + '"></div>' +
            '<div class="bg-3d-preview__controls">' +
              '<button class="bg-3d-preview__fb" data-face="front">Front</button>' +
              '<button class="bg-3d-preview__fb" data-face="back">Back</button>' +
            '</div>';

          const scene = wrap.querySelector('.bg-3d-preview__scene');
          scene.style.height = '100%';
          scene.style.paddingTop = '0';
          scene.style.maxHeight = '100%';

          scene.innerHTML =
            '<div class="bg-3d-preview__face front  ' + opt.finish + '"></div>' +
            '<div class="bg-3d-preview__face back   ' + opt.finish + '"></div>' +
            '<div class="bg-3d-preview__edge left"></div>' +
            '<div class="bg-3d-preview__edge right"></div>' +
            '<div class="bg-3d-preview__edge top"></div>' +
            '<div class="bg-3d-preview__edge bottom"></div>';

          scene.querySelector('.front').style.backgroundImage = 'url(\'' + imgs[0] + '\')';
          scene.querySelector('.back').style.backgroundImage = 'url(\'' + (imgs[1] || imgs[0]) + '\')';

          let angleY = opt.initialAngle;
          let angleX = 0;
          let spinning = !!opt.autoRotate;
          let wobbling = !!opt.wobble && !spinning;
          let rafId = null;
          let lastTs = null;

          function applyTransform() {
            scene.style.transform = 'rotateX(' + angleX + 'deg) rotateY(' + angleY + 'deg)';
            const p = (((angleY % 360) + 360) % 360) / 360 * 100;
            scene.style.setProperty('--shine', p.toFixed(1) + '%');
          }

          function stopMotion() {
            spinning = wobbling = false;
            scene.classList.remove('autospin', 'wobble');
          }

          function fitToViewport() {
            const hidden = (mount.offsetParent === null) || getComputedStyle(mount).display === 'none';
            if (hidden) {
              requestAnimationFrame(fitToViewport);
              return;
            }

            const box = mount.getBoundingClientRect();
            const parentW = box.width || window.innerWidth;
            const parentH = box.height || window.innerHeight;

            const margin = 0.01; // leave a minimal gutter to avoid overflow
            const maxW = parentW * (1 - margin);
            const maxH = parentH * (1 - margin);
            let w = maxW;
            let h = w / ar;
            if (h > maxH) {
              h = maxH;
              w = h * ar;
            }
            wrap.style.width = w + 'px';
            wrap.style.maxWidth = w + 'px';
            wrap.style.height = h + 'px';
            wrap.style.maxHeight = h + 'px';
          }

          fitToViewport();
          window.addEventListener('resize', fitToViewport);

          const degPerMs = 360 / (opt.rotateSpeed * 1000);
          function loop(ts) {
            if (spinning && lastTs) {
              angleY += (ts - lastTs) * degPerMs;
              applyTransform();
            }
            lastTs = ts;
            rafId = requestAnimationFrame(loop);
          }
          rafId = requestAnimationFrame(loop);
          if (wobbling) scene.classList.add('wobble');
          applyTransform();

          const flipTo = function (targetDeg) {
            stopMotion();
            const diff = ((targetDeg - angleY + 540) % 360) - 180;
            const start = angleY;
            const dur = 400;
            const t0 = performance.now();
            const ease = function (t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; };

            const anim = function (now) {
              const p = Math.min(1, (now - t0) / dur);
              angleY = start + diff * ease(p);
              applyTransform();
              if (p < 1) requestAnimationFrame(anim);
            };
            requestAnimationFrame(anim);
          };

          wrap.querySelectorAll('.bg-3d-preview__fb').forEach(function (btn) {
            btn.addEventListener('click', function () {
              flipTo(btn.dataset.face === 'front' ? 0 : 180);
            });
          });

          let dragging = false;
          let sx = 0;
          let sy = 0;
          let syaw = 0;
          let spitch = 0;
          const onDown = function (e) {
            dragging = true;
            stopMotion();
            sx = e.clientX;
            sy = e.clientY;
            syaw = angleY;
            spitch = angleX;
          };
          const onMove = function (e) {
            if (!dragging) return;
            const dx = e.clientX - sx;
            const dy = e.clientY - sy;
            angleY = syaw + dx;
            angleX = Math.max(-30, Math.min(30, spitch - dy * 0.3));
            applyTransform();
          };
          const endDrag = function () { dragging = false; };

          scene.addEventListener('pointerdown', onDown);
          window.addEventListener('pointermove', onMove);
          window.addEventListener('pointerup', endDrag);
          window.addEventListener('pointercancel', endDrag);

          const modalHost = wrap.closest('.bg-custom-modal, #bg-design-modal');
          if (modalHost) {
            modalHost.addEventListener('modal:close', function () {
              cancelAnimationFrame(rafId);
              window.removeEventListener('resize', fitToViewport);
              window.removeEventListener('pointermove', onMove);
              window.removeEventListener('pointerup', endDrag);
              window.removeEventListener('pointercancel', endDrag);
            }, { once: true });
          }
        }
      }
    };
  })();
})();

// Quote Tool runtime hardening (site-specific JSON + stale discount node guard)
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.__bgQuoteToolRuntimeShimInit) return;
  window.__bgQuoteToolRuntimeShimInit = true;

  function isQuoteToolPage() {
    if (window.__bgQuoteToolContext) return true;
    return /\/pages\/(?:quote-tool|internal-staff-tools-v2|internal-staff-tools)(?:\/|$)/i.test(String(window.location && window.location.pathname || ''));
  }

  function detectSiteKey() {
    const seeded = String(window.__bgDataSiteKey || '').trim().toLowerCase();
    if (seeded) return seeded;
    const host = String(window.location && window.location.hostname || '').toLowerCase();
    if (host.indexOf('boguna') !== -1 || host.indexOf('4492ca-12') !== -1) return 'boguna';
    if (host.indexOf('wcrmarketing') !== -1 || host.indexOf('windowcleaner-print') !== -1) return 'wcrmarketing';
    return '';
  }

  function rewriteQuoteDataUrl(inputUrl, siteKey) {
    if (!inputUrl || !siteKey) return '';
    if (siteKey !== 'boguna') return '';

    const swapMap = {
      'bg-master-pricing-data.json': 'bg-master-pricing-data-boguna.json',
      'bg-option-layout-data.json': 'bg-option-layout-data-boguna.json',
      'bg-product-data-list.json': 'bg-product-data-list-boguna.json'
    };

    let parsed;
    try {
      parsed = new URL(String(inputUrl), window.location.origin);
    } catch (_) {
      return '';
    }

    const path = String(parsed.pathname || '');
    const filename = path.split('/').pop();
    const nextName = swapMap[filename];
    if (!nextName) return '';

    parsed.pathname = path.slice(0, path.length - filename.length) + nextName;
    return parsed.toString();
  }

  function installFetchRewriteShim() {
    if (window.__bgQuoteToolFetchRewriteShimInstalled) return;
    if (typeof window.fetch !== 'function') return;
    const siteKey = detectSiteKey();
    if (!siteKey) return;

    const originalFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      if (!isQuoteToolPage()) {
        return originalFetch(input, init);
      }

      let sourceUrl = '';
      if (typeof input === 'string') {
        sourceUrl = input;
      } else if (input && typeof input.url === 'string') {
        sourceUrl = input.url;
      }

      const rewritten = rewriteQuoteDataUrl(sourceUrl, siteKey);
      if (!rewritten || rewritten === sourceUrl) {
        return originalFetch(input, init);
      }

      if (typeof input === 'string') {
        return originalFetch(rewritten, init);
      }

      try {
        const request = new Request(rewritten, input);
        return originalFetch(request, init);
      } catch (_) {
        return originalFetch(rewritten, init);
      }
    };

    window.__bgQuoteToolFetchRewriteShimInstalled = true;
  }

  function stripStaleDiscountNodes() {
    if (!isQuoteToolPage()) return;
    const nodes = document.querySelectorAll('[data-discount]');
    if (!nodes || !nodes.length) return;
    nodes.forEach(function (node) {
      try {
        node.removeAttribute('data-discount');
      } catch (_) {}
    });
  }

  function installDiscountNodeGuard() {
    if (window.__bgQuoteToolDiscountNodeGuardInstalled) return;
    if (!isQuoteToolPage()) return;

    stripStaleDiscountNodes();
    const observer = new MutationObserver(function (mutations) {
      for (let i = 0; i < mutations.length; i++) {
        const mutation = mutations[i];
        const target = mutation && mutation.target;
        if (!(target instanceof HTMLElement)) continue;
        if (!target.hasAttribute('data-discount')) continue;
        try {
          target.removeAttribute('data-discount');
        } catch (_) {}
      }
    });

    try {
      observer.observe(document.documentElement || document.body, {
        attributes: true,
        subtree: true,
        attributeFilter: ['data-discount']
      });
      window.__bgQuoteToolDiscountNodeGuardInstalled = true;
      window.__bgQuoteToolDiscountNodeGuardObserver = observer;
    } catch (_) {
      window.__bgQuoteToolDiscountNodeGuardInstalled = true;
    }
  }

  function enforceQuoteToolLoginGate() {
    if (!isQuoteToolPage()) return;
    const root = document.querySelector('.bg-quote-tool');
    if (!(root instanceof HTMLElement)) return;

    if (root.classList.contains('bg-quote-tool--blocked')) {
      root.classList.remove('bg-quote-tool--blocked');
    }

    const accessEl = root.querySelector('[data-role="quote-tool-access"]');
    if (accessEl instanceof HTMLElement) {
      accessEl.hidden = true;
      accessEl.style.setProperty('display', 'none', 'important');
    }
  }

  function installQuoteToolLoginGateGuard() {
    if (window.__bgQuoteToolLoginGateGuardInstalled) return;
    if (!isQuoteToolPage()) return;

    enforceQuoteToolLoginGate();
    window.__bgQuoteToolLoginGateGuardInstalled = true;
  }

  function init() {
    enforceQuoteToolLoginGate();
    installQuoteToolLoginGateGuard();
    installFetchRewriteShim();
    installDiscountNodeGuard();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
  function hasQuoteToolCustomerSession() {
    const customer = (window && window.customerData && typeof window.customerData === 'object') ? window.customerData : null;
    if (customer && (customer.id || customer.email)) return true;

    const tagsSource = customer ? customer.tags : null;
    if (Array.isArray(tagsSource) && tagsSource.length) return true;
    if (!Array.isArray(tagsSource) && String(tagsSource || '').trim()) return true;

    const shopify = (window && window.Shopify && typeof window.Shopify === 'object') ? window.Shopify : null;
    if (shopify && (shopify.customer_id || shopify.customerId)) return true;

    try {
      if (document.documentElement && document.documentElement.classList.contains('customer-logged-in')) return true;
      if (document.body && document.body.classList.contains('customer-logged-in')) return true;
    } catch (_) {}

    return false;
  }
